import React, { FC, FormEvent } from "react";
import { useNavigate } from "react-router-dom";

import { toast } from "react-toastify";

import {
  useProvidersCurrentEmployee,
  useInput,
  useMultipleDropdown,
} from "~/hooks";

import { useApisManagersBusinessDivisionsEdit } from "../hooks/useApisManagersBusinessDivisionsEdit";
import { useApisManagersBusinessDivisionsUpdate } from "../hooks/useApisManagersBusinessDivisionsUpdate";

import {
  Form,
  FormSubmitButton,
  LabelWithMultipleDropdownField,
  LabelWithTextField,
} from "~/ui";

type PropsType = {
  businessDivisionId: string;
};

export const BusinessDivisionEditForm: FC<PropsType> = ({
  businessDivisionId,
}) => {
  const navigate = useNavigate();
  const { refetch } = useProvidersCurrentEmployee();
  const [
    {
      dropdownValue: selectedCurrentDivisionManagers,
      onChange: onChangeCurrentDivisionManagers,
      dropdownSelectableValue: selectableCurrentDivisionManagers,
      setSelectableOption: setSelectableCurrentDivisionManagers,
    },
  ] = useMultipleDropdown();

  const [
    { value: businessDivisionName, onChange: onChangeBusinessDivisionName },
    setBusinessDivisionName,
  ] = useInput("");

  const { isError } = useApisManagersBusinessDivisionsEdit({
    id: businessDivisionId,
    config: {
      onSuccess: (res) => {
        setBusinessDivisionName(res.businessDivision.name);
        onChangeCurrentDivisionManagers(
          res.currentDivisionManagers.map((manager) => ({
            label: manager.name,
            value: manager.id,
          })),
        );
        setSelectableCurrentDivisionManagers(
          res.divisionEmployees.map((employee) => ({
            name: employee.name,
            id: employee.id,
          })),
        );
      },
    },
  });

  const { mutate, isLoading: isSubmitting } =
    useApisManagersBusinessDivisionsUpdate();

  if (isError) {
    return null;
  }

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    mutate(
      {
        id: businessDivisionId,
        body: {
          name: businessDivisionName,
          managerEmployeeIds: selectedCurrentDivisionManagers?.map(
            (manager) => manager.value,
          ),
        },
      },
      {
        onSuccess: (res) => {
          navigate("/managers/business_divisions");
          toast(res.message);
          refetch();
        },
      },
    );
  };

  console.log({ selectedCurrentDivisionManagers });

  return (
    <Form onSubmit={handleSubmit} className="space-y-6">
      <LabelWithTextField
        labelText="部署名"
        type="text"
        name="businessDivision"
        required
        placeholder="部署名"
        value={businessDivisionName}
        onChange={onChangeBusinessDivisionName}
      />
      <LabelWithMultipleDropdownField
        labelText="部署マネージャー"
        name="currentDivisionManagers"
        options={selectableCurrentDivisionManagers}
        value={selectedCurrentDivisionManagers}
        onChange={onChangeCurrentDivisionManagers}
      />
      <FormSubmitButton
        color="primary"
        className="w-full"
        value="保存"
        isReadOnly={isSubmitting}
      />
    </Form>
  );
};
